import React from 'react';
import { useHistory } from 'react-router-dom';

import { getSocketIo } from '@client/store/globalStore/init/socketIo';
import i18n from '@client/utils/i18n';
import lediumApi from '@client/utils/lediumApi';
import { TitleAndDescription } from '@ledium/ui-common';
import { Container, Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import DashboardProject, { DashboardProjectItem, ProjectSocketData } from './Components/DashboardProject';

const Dashboard = () => {
    const history = useHistory();

    const [loading, setLoading] = React.useState(true);
    const [projectList, setProjectList] = React.useState<DashboardProjectItem[]>([]);
    const [projectData, setProjectData] = React.useState<Record<string, ProjectSocketData | null>>({});

    const socket = getSocketIo();
    React.useEffect(() => {
        socket.on('project_status', (data: ProjectSocketData) => {
            setProjectData((prev) => ({
                ...prev,
                [data.projectId]: data
            }));
        });

        return () => {
            socket.off('project_status');
        };
    }, [socket]);

    function refreshProjects() {
        lediumApi.get<DashboardProjectItem[]>('projects/getDashboard/').then((projects) => {
            if (projects) {
                setProjectList(projects);
            }
        });
    }

    function onClickAddNewProject() {
        history.push('/projects/new');
    }

    function handleStopProject(projectId: string) {
        setProjectData((prev) => ({
            ...prev,
            [projectId]: null
        }));
        refreshProjects();
    }

    React.useEffect(() => {
        lediumApi.get<DashboardProjectItem[]>('projects/getDashboard/').then((projects) => {
            if (projects) {
                setProjectList(projects);
            }
            setLoading(false);
        });
    }, []);

    return (
        <Container>
            <Grid container spacing={3}>
                <TitleAndDescription />

                {!projectList.length && !loading ? (
                    <>
                        <Grid item xs={12}>
                            <Typography variant="body1">{i18n('no_project')}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" onClick={onClickAddNewProject}>
                                {i18n('add_new_project')}
                            </Button>
                        </Grid>
                    </>
                ) : null}
                {projectList.map((project) => (
                    <Grid item xs={12} key={project.id}>
                        <DashboardProject
                            project={project}
                            projectData={projectData[project.id]}
                            refreshProjects={refreshProjects}
                            handleStopProject={handleStopProject}
                        />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default React.memo(Dashboard);
